'use strict';

import Recommendations from '@jsclasses/recommendations';

// Selector
const selector = {
  recommendations: '.js-pdp__recommendations',
  recommendationsAddons: '.js-pdp__recommendations-addons'
};

// Elements
const element = {};

// Functions

/**
 * Initializes the recommendations
 * @returns {void}
 */
const initRecommendations = () => {
  initElements();
  if (element.recommendations) {
    new Recommendations({
      wrapper: element.recommendations[0],
      showPrice: true,
      maxVisibleItems: 5
    });
  }

  if (
    element.recommendationsAddons &&
    element.recommendationsAddons.length > 0
  ) {
    new Recommendations({
      wrapper: element.recommendationsAddons[0],
      showPrice: true,
      maxVisibleItems: 5
    });
  }
};

const initElements = () => {
  element.recommendations =
    document.querySelectorAll(selector.recommendations) || null;
  element.recommendationsAddons =
    document.querySelectorAll(selector.recommendationsAddons) || null;
};

export { initRecommendations };
